var _circle, _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClimateControl24 = function SvgClimateControl24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 18,
    r: 2.25,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.25 7.5h1.5v8.25h-1.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.25,
    y: 7.5,
    width: 1.5,
    height: 9,
    rx: 0.75,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5a2.7 2.7 0 0 0-1.928.817 2.825 2.825 0 0 0-.8 1.97v9.959a4.6 4.6 0 0 0-1.575 2.311 4.692 4.692 0 0 0 .04 2.816 4.592 4.592 0 0 0 1.639 2.264A4.436 4.436 0 0 0 9 22.5c.942 0 1.86-.302 2.624-.863a4.591 4.591 0 0 0 1.64-2.264 4.692 4.692 0 0 0 .039-2.816 4.599 4.599 0 0 0-1.575-2.311V4.303a2.82 2.82 0 0 0-.8-1.97A2.702 2.702 0 0 0 9 1.516V1.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.25h6m-6 3h6m-6-6h6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgClimateControl24;